import { Step } from "react-joyride";

export const getClassesTourSteps = (): Step[] => [
  {
    target: 'h1',
    content: 'Aquí encontrarás todas las clases disponibles en tu gimnasio.',
    placement: 'center',
  },
  {
    target: '.toggle-group',
    content: 'Puedes filtrar entre todas las clases, tus clases inscritas o las clases que impartes.',
    placement: 'bottom',
  },
  {
    target: '.relative input',
    content: 'Busca clases por nombre, instructor o descripción.',
    placement: 'bottom',
  },
  {
    target: '.grid.grid-cols-1',
    content: 'Aquí verás la lista de clases disponibles. Puedes inscribirte o cancelar tu inscripción haciendo clic en el botón de cada clase.',
    placement: 'top',
  }
];